import PageWithHeaderLayout from '@/app/layouts/PageWithHeader.layout';
import { PriceInfoSkeleton, StationInfoSkeleton } from '@/features/station';
import { useBoundStore } from '@/shared/store';

const StationDetailPageSkeleton = () => {
	const dispatch = useBoundStore((store) => store.dispatch);

	return (
		<PageWithHeaderLayout
			title="주유소 상세"
			showBackButton
			onClickBackButton={() => dispatch({ type: 'back' })}
		>
			<div className="flex flex-col items-center p-5">
				<StationInfoSkeleton />
				<section className="flex self-stretch px-1 py-2">
					<PriceInfoSkeleton />
					<PriceInfoSkeleton />
				</section>
			</div>
		</PageWithHeaderLayout>
	);
};

export default StationDetailPageSkeleton;
